import { useState } from "react";
import {
	CorporateAccountingAnswers,
	corporateAccountingLabels,
	corporateAccountingQuestionOrder,
	isCorporateAccountingFieldActive,
	normalizeCorporateAccounting,
} from "common/utils/corporateAccounting";
import RadioInputElement from "components/materials/Form/RadioInputElement";
import InputElement, { EInputType } from "components/materials/Form/InputElement";

export default function CorporateAccountingQuestions({ initialAnswers, readonly = false }: { initialAnswers: CorporateAccountingAnswers; readonly?: boolean }) {
	const [answers, setAnswers] = useState(() => normalizeCorporateAccounting(initialAnswers));
	return (
		<section aria-label="Comptabilité et fiscalité de votre société" style={{ display: "grid", gap: "24px" }}>
			<div>
				<h3>Comptabilité et fiscalité de votre société</h3>
				<p>
					Ces informations permettent de préciser la situation comptable et fiscale de votre société pour cet investissement. Votre expert-comptable peut vous aider à y
					répondre.
				</p>
			</div>
			{corporateAccountingQuestionOrder
				.filter((field) => isCorporateAccountingFieldActive(field, answers))
				.map((field) => {
					if (field === "hexaPillar2AccountingStandards" || field === "hexaPillar2ExclusionBasis")
						return (
							<InputElement
								key={field}
								name={field}
								type={EInputType.TEXT}
								label={corporateAccountingLabels[field]}
								readonly={readonly}
								caption="300 caractères maximum"
								defaultValue={answers[field]}
								onChange={(event) => setAnswers((current) => ({ ...current, [field]: event.target.value }))}
							/>
						);
					return (
						<RadioInputElement
							key={field}
							name={field}
							label={corporateAccountingLabels[field]}
							readonly={readonly}
							options={[
								{ value: "true", label: "Oui" },
								{ value: "false", label: "Non" },
							]}
							defaultValue={answers[field]?.toString()}
							onChange={(event) => setAnswers((current) => normalizeCorporateAccounting({ ...current, [field]: event.target.value === "true" }))}
						/>
					);
				})}
		</section>
	);
}
